export const LOCATION_OPTIONS = [{ value: "help", label: "Get help" }];

export const LINK_LOCATIONS = {
  HELP: "help",
  APPS: "apps", // Legacy, being phased out
};
